var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkspacesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    y: 0.851562,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EEF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5641 19.5176H20.359C19.7926 19.5176 19.3334 19.9768 19.3334 20.5432V28.7483C19.3334 29.3148 19.7926 29.774 20.359 29.774H28.5641C29.1306 29.774 29.5898 29.3148 29.5898 28.7483V20.5432C29.5898 19.9768 29.1306 19.5176 28.5641 19.5176Z",
    stroke: "#5770CB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9744 19.5176H36.7693C36.2028 19.5176 35.7436 19.9768 35.7436 20.5432V28.7483C35.7436 29.3148 36.2028 29.774 36.7693 29.774H44.9744C45.5408 29.774 46 29.3148 46 28.7483V20.5432C46 19.9768 45.5408 19.5176 44.9744 19.5176Z",
    stroke: "#5770CB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5641 35.9278H20.359C19.7926 35.9278 19.3334 36.387 19.3334 36.9535V45.1586C19.3334 45.725 19.7926 46.1842 20.359 46.1842H28.5641C29.1306 46.1842 29.5898 45.725 29.5898 45.1586V36.9535C29.5898 36.387 29.1306 35.9278 28.5641 35.9278Z",
    stroke: "#5770CB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9744 35.9278H36.7693C36.2028 35.9278 35.7436 36.387 35.7436 36.9535V45.1586C35.7436 45.725 36.2028 46.1842 36.7693 46.1842H44.9744C45.5408 46.1842 46 45.725 46 45.1586V36.9535C46 36.387 45.5408 35.9278 44.9744 35.9278Z",
    stroke: "#5770CB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspacesIcon);
export default __webpack_public_path__ + "static/media/workspaces-icon.56fccffd.svg";
export { ForwardRef as ReactComponent };